import { Component, OnInit } from '@angular/core';


import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CalendlyService } from 'src/app/services/calendly.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dynamic-365',
    imports: [],
    templateUrl: './dynamic-365.component.html',
    styleUrls: ['./dynamic-365.component.css']
})
export class Dynamic365Component implements OnInit {
  public calendlyUrl = environment.CALENDLY_URL;
  contactForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.required, Validators.email]),
    company: new FormControl(''),
    message: new FormControl('', Validators.required)
  });

  isSubmitting = false;
  submitted = false;

  constructor(private calendly: CalendlyService) { }

  ngOnInit(): void { }

  openCalendlyPopup() {
    return this.calendly.openPopup(this.calendlyUrl);
  }

  onSubmit(): void {
    if (!this.contactForm.valid) {
      this.contactForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    setTimeout(() => {
      this.isSubmitting = false;
      this.submitted = true;
      this.contactForm.reset();
      setTimeout(() => {
        this.submitted = false;
      }, 5000);
    }, 1500);
  }

}
